export const HinhThuc = {
   FullTime: "Full Time",
   PartTime: "Part Time",
};
